"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const use_query_parameters_1 = require("@src/helpers/use-query-parameters");
const react_1 = __importDefault(require("react"));
const _1 = __importDefault(require("."));
const AdminOrderPage = () => {
    const { getQueryParams } = (0, use_query_parameters_1.useQueryParameters)();
    const queryParams = getQueryParams();
    const { product: productId, amount, offerId } = queryParams;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(_1.default, { productId: parseInt(productId, 10), amount: parseInt(amount, 10) || undefined, offerId: parseInt(offerId, 10) || undefined }) }));
};
exports.default = AdminOrderPage;
